import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { AppContexts } from "../../../providers";

const TrialAccount = () => {
  const { user } = useContext(AppContexts.AuthContext);
  const location = useLocation();

  const isTrialUser =
    (user?.details.type === "trial" || user?.details.type === "trial-full") &&
    moment(user.details.trial_end) > moment();

  const hideGettingStartedLink =
    !!user?.guide_onboarding?.completed_at ||
    !!user?.guide_onboarding?.dismissed_at ||
    location.pathname === "/getting-started" ||
    location.pathname === "/ai-assistant";

  const dismissedOnboarding =
    user?.guide_onboarding?.dismissed_at &&
    !user.guide_onboarding.completed_at;
  const legacyExitedOnboarding =
    user?.guide_onboarding?.completed_at &&
    user.guide_onboarding.current_step !== "send";
  const canResumeOnboarding =
    dismissedOnboarding || legacyExitedOnboarding;
  const resumeStep = user?.guide_onboarding?.current_step || "property";

  const oneUnitLimit =
    location.pathname === "/properties" || location.pathname === "/areas";

  return (
    <>
      {isTrialUser && (
        <div className="trial-account-panel">
          <div className="trial-account-banner">
            <span className="trial-account-copy">
              <strong>
                {moment(user?.details.trial_end).diff(moment(), "days")} days
              </strong>{" "}
              left in your free trial
            </span>
            <a className="trial-account-action" href="/billing">
              Start subscription
            </a>
          </div>
          {(oneUnitLimit || canResumeOnboarding || !hideGettingStartedLink) && (
            <div className="trial-account-links">
              {oneUnitLimit && (
                <span className="trial-account-note">
                  Subscription is required to add more than one guide.
                </span>
              )}
              {canResumeOnboarding && (
                <a
                  href={`/guide-designer?onboarding=${encodeURIComponent(
                    resumeStep,
                  )}`}
                >
                  Continue onboarding
                </a>
              )}
              {!hideGettingStartedLink && (
                <a href="/getting-started">Back to Getting Started</a>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TrialAccount;
